import { useEffect } from 'react';
import Raven from 'raven-js';
import { useGetAppIdsQuery } from '../../../../__generated__/chirp/com/hubspot/dashworks/rpc/DashworksRpc.hooks';
export const useDashworksAppIds = () => {
  const {
    data,
    loading,
    error,
    networkStatus
  } = useGetAppIdsQuery();
  useEffect(() => {
    if (error) {
      Raven.captureException(error);
    }
  }, [error]);
  return {
    data: (data === null || data === void 0 ? void 0 : data.appIds) || [],
    isLoading: loading,
    error: error || null,
    networkStatus
  };
};